import resume from '../assets/pdf/resume.pdf'

export const headerData = {
  name: "Swapnil Kapadnis",
  title: " Fullstack Web Developer",
  desciption:
    "Detailed-oriented and responsible Full-Stack Web Developer with a great knowledge of Web Development. ",
  image: "https://i.ibb.co/GWhgqvP/20220907-121548.png",
  resumePdf: resume,
};
